import { getValuesForSelectedOptions } from 'commons/productUtils';
import { useCallback } from 'react';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import useProductFavoriteV2 from '../useProductFavoriteV2';

const getEventData = ({
  product,
  price,
  optionPrice,
  options,
  selectedOptions,
  isFavorited = false,
  isDecideLater = false,
}) => {
  const { fabric } = getValuesForSelectedOptions(options, selectedOptions);
  return {
    fabric_id: fabric?.id || 0,
    fabric_name: isDecideLater ? 'Decide Later' : fabric?.value || '',
    fabric_color: fabric?.color || '',
    favorited: isFavorited,
    product_id: product.id,
    product_name: product.name,
    price: price.final_price + optionPrice,
    full_price: price.original_price + optionPrice,
    product_family: product.family?.name,
    product_type: product.type.name,
  };
};

const usePDPFullScreenClickEvent = (basicDetails, optionData, priceData) => {
  const { isFavorited } = useProductFavoriteV2();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();

  const fullScreenClickEvent = useCallback(() => {
    getEventData({
      isFavorited,
      product: basicDetails,
      price: priceData?.price,
      optionPrice: priceData?.optionPrice,
      options: optionData.options,
      selectedOptions: optionData.selectedOptions,
      isDecideLater: pdpSelectedCustomizerTab === 'decide-later',
    });
  }, [
    isFavorited,
    basicDetails,
    priceData?.price,
    priceData?.optionPrice,
    optionData.options,
    optionData.selectedOptions,
    pdpSelectedCustomizerTab,
  ]);

  return {
    fullScreenClickEvent,
  };
};

export default usePDPFullScreenClickEvent;
